import * as actionTypes from '../actions';

const initialState = {
  list: []
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PRODUCT_LIST: {

      return {
        ...initialState,
        list: action.data
      };
    }

    case actionTypes.PRODUCT_CLEAR: {
      return {
        list: []
      }
    }

    default: {
      return state;
    }
  }
};

export default productReducer;
